module.exports = __webpack_public_path__ + "img/temtem.a34785e3.png";